module.exports = __webpack_public_path__ + "static/media/img9.5bfed960.jpg";